export default function Section5() {
  return (
    <div className="Section5">
      <div className="section5-container my-[4%] md:my-0 md:justify-evenly md:items-center md:flex px-[20px] md:p-[50px_30px_0px_30px]">
        <div className="md:w-[36%] mb-[30px] md:mb-0">
          <h2 className="text-[24px] md:text-[34px] leading-[32px] md:leading-[35px] font-bold text-[#DA2128] my-[0.67em]">
            Elevate Your Brand with Influencer Marketing
          </h2>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            Ready to leverage the power of influencers to boost your brand's visibility and credibility? Contact us today for a free consultation. Together, we'll create an influencer marketing strategy that not only drives brand awareness but also builds trust with your audience. <br/> Don't miss out on the opportunities that influencer marketing can bring to your business. Partner with Mean3 and take your brand to new heights with influencer-driven success.
          </p>

          <div className="btn-cont">
            <a
              href="#influencer-marketing-contact"
              className="bg-[#DA2128] text-white rounded-[3px] inline-block p-[10px_15px] text-[14px] font-bold leading-[1.15]"
            >
              Get Started
            </a>
          </div>
        </div>

        <div className="w-full img-cont md:w-auto">
          <img
            className="w-full md:w-auto"
            src="/assets/chimp-image-influencer-marketing.png"
          ></img>
        </div>
      </div>

      <div className="line mx-auto my-[55px] md:my-[4%]  w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
